import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-cities',
  imports: [RouterOutlet],
  templateUrl: './cities.html',
  styleUrl: './cities.scss',
})
export class Cities {

}
